import React from 'react';
import { UseServiceHealthResult } from '../../../hooks/health/use-service-health';
import { ProbeStatus, worstStatus } from '../types';
import Chip from '../chip';
import StatusPill from '../status-pill';

interface Props {
	health: UseServiceHealthResult;
}

/** "Is the service up", where the rest of the dashboard asks "is this room working". */
export default function ServiceHealthPanel({ health }: Props) {
	const { services, refresh } = health;
	const rollup = worstStatus(services.map((service) => service.probe.status));

	return (
		<section className='health-panel'>
			<header className='health-panel__header'>
				<div>
					<h3 className='health-panel__title'>Service health</h3>
					<span className='health-panel__source'>greenroom services</span>
				</div>
				<div className='health-panel__status'>
					<StatusPill status={rollup} />
					<button type='button' className='health-link-button' onClick={refresh}>
						Check now
					</button>
				</div>
			</header>

			<div className='health-panel__body'>
				{!services.length && <p className='health-panel__note'>Checking…</p>}

				<div className='health-chips'>
					{services.map(({ key, label, probe }) => (
						<Chip
							key={key}
							label={label}
							value={probe.status === ProbeStatus.Error
								? probe.message ?? `http ${probe.httpStatus}`
								: `${probe.latencyMs}ms`}
							tone={probe.status === ProbeStatus.Error ? 'warn' : 'on'}
							mono
						/>
					))}
				</div>

				{services.some((service) => service.probe.status === ProbeStatus.Error) && (
					<p className='health-subtle'>
						A failing check here is the service itself, not this room — everything
						above it will be failing too.
					</p>
				)}
			</div>
		</section>
	);
}
